import * as qualificationSideBarActions from "app/action_types/qualification_side_bar_action_types";
import type { QualificationSideBarSelectionType } from "app/components/QualificationSideBar/types";

export const toggleQualififcationSideBarAction = (isQualificationSideBarOpened: boolean) => {
    return {
        type: qualificationSideBarActions.TOGGLE_QUALIFICATION_SIDE_BAR,
        isQualificationSideBarOpened,
    };
};

export const setQualificationSideBarSelectionAction = (selection: QualificationSideBarSelectionType) => {
    return {
        type: qualificationSideBarActions.SET_QUALIFICATION_SIDE_BAR_SELECTION,
        qualificationSideBarSelection: selection,
    };
};
